import styles from './Projects.module.css';
import { motion } from 'framer-motion';

const Projects = () => {
  return (
    <div className={styles.projects}>
      <motion.h1 animate={{ y: 10 }} className={styles.projects_title}>
        Projekts
      </motion.h1>
      <hr className={styles.hr_projects_hr}></hr>
      <div className={styles.column_left}>
        <p className={styles.p}>Vi har ufört följande project</p>
        <p className={styles.p}> till kunder runt om i sverige:</p>
      </div>
      <div className={styles.column_right}>
        <ul>
          <h3 className={styles.h3}>Projekt lista</h3>
          <li className={styles.li}>
            Installation av anläggnings El
            <ol>
              Följande kunder:
              <li style={{ listStyle: 'circle', marginLeft: '50px' }}>
                Nordifa AB
              </li>
              <li style={{ listStyle: 'circle', marginLeft: '50px' }}>
                HFAB Vallås
              </li>
              <li style={{ listStyle: 'circle', marginLeft: '50px' }}>
                HFAB Maratonvägen
              </li>
            </ol>
          </li>
          <li className={styles.li}>
            Installation av Industri maskiner
            <ol>
              Följande kunder:
              <li style={{ listStyle: 'circle', marginLeft: '50px' }}>
                Nordifa AB
              </li>
            </ol>
          </li>
        </ul>
      </div>
      <div className={styles.clear}></div>
      <div className={styles.distancer}></div>
    </div>
  );
};

export default Projects;
